import React from 'react';

import { AlmeMinimizeConfig } from './AlmeMinimizeConfig';
import AlmeConfigFormControl, { BoolPropTypes, ConfigControlGroups } from '../AlmeConfigFormControl/AlmeConfigFormControl';
import { SvgIconProps } from '@material-ui/core';

interface AlmeMinimizeConfigToolProps {
    almeConfig: AlmeMinimizeConfig;
    onConfigChange: (almeConfig: AlmeMinimizeConfig) => void;
}

const AlmeMinimizeConfigTool: React.FC<AlmeMinimizeConfigToolProps> = (props: AlmeMinimizeConfigToolProps) => {
    const isEnabled = props.almeConfig.minimize.isMinimizeEnabled.toString() as BoolPropTypes;
    const minimizeButtonSize = props.almeConfig.minimize.styles.buttonSize;

    const setIsEnabled = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value;
        const almeConfig = props.almeConfig;
        almeConfig.minimize.isMinimizeEnabled = newValue === 'true';
        props.onConfigChange(almeConfig);
    };

    const setMinimizeButtonSize = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as SvgIconProps['fontSize'];
        const almeConfig = props.almeConfig;
        almeConfig.minimize.styles.buttonSize = newValue;
        props.onConfigChange(almeConfig);
    };

    const configControls: ConfigControlGroups[] = [
        {
            name: 'Minimize Button',
            controlGroups: [
                {
                    label: 'Is Enabled',
                    name: 'isEnabled',
                    value: isEnabled,
                    changeHandler: setIsEnabled,
                    radioButtons: ['true', 'false'],
                },
                {
                    label: 'Minimize Button Size',
                    name: 'minimizeButtonSize',
                    value: minimizeButtonSize,
                    changeHandler: setMinimizeButtonSize,
                    radioButtons: ["small", "inherit", "default", "large"],
                },
            ],
        },
    ];

    return (
        <AlmeConfigFormControl title='Alme Minimize Config' configControls={configControls} />
    );
};

export default AlmeMinimizeConfigTool;
